import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  FormControlLabel,
  Grid,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import KenCard from '../../../../../global_components/KenCard';
import KenInputField from '../../../../../global_components/KenInputField';
import { AiOutlineMinusSquare } from 'react-icons/ai';
import { AiOutlinePlusSquare } from 'react-icons/ai';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AiFillDelete, AiOutlineEdit } from 'react-icons/ai';
import { BsCheck2All } from 'react-icons/bs';

import Switch from '@material-ui/core/Switch';
import './grading.css';

const scaleArr = [
  {
    id: 1,
    iconChecked: false,
    rows: [],
  },
];
let count = 1;

const createData = (id, gradepoint, gradeNum, saved) => ({
  id,
  gradepoint,
  gradeNum,
  saved,
});
const GradeScale = () => {
  const [scales, setScales] = useState(scaleArr);
  const [accordienCheck, setAccordienCheck] = useState(true);
  const [minimumComponent, setMinimumComponent] = useState([{ value: 0 }]);
  const [maximumComponent, setMaximumComponent] = useState([{ value: 0 }]);
  const [maximum, setMaximum] = useState([{ value: 0 }]);
  const [minimum, setMinimum] = useState([{ value: 0 }]);
  const [state, setState] = React.useState({
    minimum: '',
    maximum: '',
  });
  const [expanded, setExpanded] = React.useState(false);
  const [checked, setChecked] = React.useState();

  useEffect(() => {
    console.log('scale---->>>', scales);
  }, [scales]);

  const handleScaleAccordien = () => {
    count++;
    setScales((pre) => [
      ...pre,
      {
        id: count,
        rows: [],
      },
    ]);
  };

  const handleGrade = (e, index) => {
    const minVal = [...minimumComponent];
    minVal.splice(index, 0, { value: e.target.value });
    setMinimumComponent(minVal);
  };
  const handleMaximumComponent = (e, index) => {
    const maxVal = [...maximumComponent];
    maxVal.splice(index, 0, { value: e.target.value });
    setMaximumComponent(maxVal);
  };
  const handleScale = (index) => {
    // if (minimumComponent[index]?.value > maximumComponent[index]?.value) {
    //   toast.error('minimum should not greater than maximum grade');
    //   return;
    // }
    scales.map((eleData, i) => {
      let diff =
        maximumComponent[index]?.value - minimumComponent[index]?.value + 1;
      let valueCheck = Math.sign(diff);
      if (valueCheck == -1) {
        toast.error('minimum should not greater than maximum grade');
        return;
      }
      let grade = maximumComponent[index]?.value;
      if (isNaN(diff)) {
        toast.error('please enter the correct range');
      } else {
        const news = new Array(diff).fill().map((datas, index) => {
          console.log('id', index);
          return {
            id: index + 1,
            val1: grade--,
            val2: '',
            isSaved: false,
          };
        });
        setScales((pre) => {
          return pre.map((e) => {
            if (index + 1 == e.id) {
              return { ...e, rows: news };
            } else {
              return e;
            }
          });
        });
      }
    });
  };
  const handleNewRow = (scaleId, id) => {
    const row = {
      id: id + 1,
      val1: '',
      val2: '',
      isSaved: false,
    };
    setScales((pre) => {
      return pre.map((e, i) => {
        if (scaleId == e.id) {
          const rows = [
            ...e.rows,
            {
              id: e.rows.length + 1,
              val1: '',
              val2: '',
              isSaved: false,
            },
          ];
          return { ...e, rows };
        } else {
          return e;
        }
      });
    });
  };

  const handleAllSave = (scaleId, id, iconCheck) => {
    // setIconCheck(true);
    setScales((pre) => {
      return pre.map((eleData) => {
        if (true) {
          const rows = eleData.rows.map((data) => {
            if (true) {
              return {
                ...data,
                val1: data.val1,
                val2: data.val2,
                isSaved: true,
              };
            }
          });
          return { ...eleData, iconChecked: true, rows };
        }
      });
    });
  };
  const handleChangeAccordien = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeSwitch = (panel1) => (event, checked) => {
    setChecked(checked ? panel1 : false);
  };

  const EditHandle = (scaleId, id, aId) => {
    setScales((pre) => {
      return pre.map((eleData) => {
        if (scaleId == eleData.id) {
          const rows = eleData.rows.map((data) => {
            if (id == data.id) {
              return {
                ...data,
                val1: data.val1,
                val2: data.val2,
                isSaved: false,
              };
            } else {
              return data;
            }
          });
          return { ...eleData, rows: rows };
        } else {
          return eleData;
        }
      });
    });
  };
  const handleChangeMax = (e, id, scaleId) => {
    setScales((pre) => {
      return pre.map((ele) => {
        if (scaleId == ele.id) {
          const rows = ele.rows.map((data) => {
            if (id == data.id) {
              return { ...data, val1: e.target.value };
            } else {
              return data;
            }
          });
          return { ...ele, rows: rows };
        } else {
          return ele;
        }
      });
    });
  };
  const handleChangeMin = (e, id, scaleId) => {
    setScales((pre) => {
      return pre.map((ele) => {
        if (scaleId == ele.id) {
          const rows = ele.rows.map((data) => {
            if (id == data.id) {
              return { ...data, val2: e.target.value };
            } else {
              return data;
            }
          });
          return { ...ele, rows: rows };
        } else {
          return ele;
        }
      });
    });
  };
  const deleteHandle = (scaleId, id) => {
    setScales((pre) => {
      return pre.map((e) => {
        if (scaleId == e.id) {
          const rows = e.rows.filter((data) => {
            if (id != data.id) {
              return data;
            }
          });
          return { ...e, rows: rows };
        } else {
          return e;
        }
      });
    });
  };
  const save = (scaleId, id, aId) => {
    setScales((pre) => {
      return pre.map((eleData) => {
        if (scaleId == eleData.id) {
          const rows = eleData.rows.map((data) => {
            if (id == data.id) {
              return {
                ...data,
                val1: data.val1,
                val2: data.val2,
                isSaved: true,
              };
            } else {
              return data;
            }
          });
          return { ...eleData, rows: rows };
        } else {
          return eleData;
        }
      });
    });
    // });
  };

  return (
    <div>
      <ToastContainer />
      <div className="cardlable">
        <span>
          <b>Default</b>
        </span>
      </div>
      <Box className="cardlsitbox">
        {scales.map((scaleData, indexId) => {
          return (
            <>
              <Accordion
                expanded={expanded === scaleData.id}
                key={indexId}
                onChange={handleChangeAccordien(scaleData.id)}
              >
                <AccordionSummary
                  expandIcon={accordienCheck}
                  onClick={() => setAccordienCheck(!accordienCheck)}
                >
                  <div className="accordion-title">
                    <div className="accordion-sub-part">
                      {!accordienCheck ? (
                        <AiOutlineMinusSquare size={20} />
                      ) : (
                        <AiOutlinePlusSquare size={20} />
                      )}{' '}
                      &nbsp;{' '}
                      <span style={{ color: '#092682', font: 'Open Sans' }}>
                        {`Scale ${indexId + 1}`}
                      </span>{' '}
                    </div>
                    <div>
                      <FormControlLabel
                        control={
                          <Switch
                            size="Scale"
                            checked={checked === scaleData.id}
                            onChange={handleChangeSwitch(scaleData.id)}
                          />
                        }
                        // label="Scale"
                      />
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails>
                  <KenCard elevation={0}>
                    <Grid container spacing={4} style={{ margin: '20px' }}>
                      <Grid item xs={12} sm={4}>
                        <KenInputField
                          label={'Minimum Grade Point'}
                          optionalLabel={false}
                          // rows={4}
                          // multiline={true}
                          value={minimumComponent[indexId]?.value}
                          onChange={(e) => handleGrade(e, indexId)}
                          style={{ fontSize: 12 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <KenInputField
                          label={'Maximun Grade Point'}
                          optionalLabel={false}
                          // rows={4}
                          // multiline={true}
                          value={maximumComponent[indexId]?.value}
                          onChange={(e) => handleMaximumComponent(e, indexId)}
                          style={{ fontSize: 12 }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Button
                          style={{ marginTop: '19px' }}
                          variant="contained"
                          color="primary"
                          // label=""
                          onClick={() => handleScale(indexId)}
                        >
                          Submit
                        </Button>
                      </Grid>
                    </Grid>
                    {scaleData.iconChecked && (
                      <Grid
                        container
                        spacing={6}
                        style={{ marginLeft: '20px', padding: '0' }}
                      >
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          style={{ paddingBottom: '0' }}
                        >
                          <span>
                            <b>Grad Point(CGPA)</b>
                          </span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          style={{ paddingBottom: '0' }}
                        >
                          <span>
                            <b>Letter grade</b>
                          </span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          style={{ paddingBottom: '0' }}
                        >
                          <span>
                            <b>Edit</b>
                          </span>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          sm={2}
                          style={{ paddingBottom: '0' }}
                        >
                          <span>
                            <b>Delete</b>
                          </span>
                        </Grid>
                      </Grid>
                    )}
                    {scaleData.rows.map((ele, i) => {
                      console.log('ellelee', ele);
                      return (
                        <>
                          {!scaleData.iconChecked && i == 0 && (
                            <Grid
                              container
                              spacing={6}
                              style={{ marginLeft: '20px', padding: '0' }}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={2}
                                style={{ paddingBottom: '0' }}
                              >
                                <span>
                                  <b>Grad Point(CGPA)</b>
                                </span>
                              </Grid>
                              <Grid
                                item
                                xs={12}
                                sm={2}
                                style={{ paddingBottom: '0' }}
                              >
                                <span>
                                  <b>Letter grade</b>
                                </span>
                              </Grid>
                            </Grid>
                          )}
                          <Grid
                            container
                            spacing={6}
                            style={{ margin: '20px' }}
                          >
                            <Grid item xs={12} sm={2}>
                              {ele.isSaved ? (
                                ele.val1
                              ) : (
                                <KenInputField
                                  // label={'Grad Point(CGPA)'}
                                  optionalLabel={false}
                                  name="minimum"
                                  value={ele.val1}
                                  onChange={(e) =>
                                    handleChangeMax(e, ele.id, scaleData.id)
                                  }
                                  // rows={4}
                                  // multiline={true}
                                  // value={cgpa}
                                  // onChange={(e) => handleCgpa(e)}
                                  style={{ fontSize: 12 }}
                                />
                              )}
                            </Grid>
                            <Grid item xs={12} sm={2}>
                              {ele.isSaved ? (
                                ele.val2
                              ) : (
                                <KenInputField
                                  // label={'Letter grade'}
                                  optionalLabel={false}
                                  // rows={4}
                                  // multiline={true}
                                  // name={maximum[indexId].value}
                                  value={ele.val2}
                                  onChange={(e) =>
                                    handleChangeMin(e, ele.id, scaleData.id)
                                  }
                                  style={{ fontSize: 12 }}
                                />
                              )}
                            </Grid>
                            {scaleData.iconChecked && !ele.isSaved ? (
                              <Grid item xs={12} sm={2}>
                                <BsCheck2All
                                  style={{ marginTop: '19px' }}
                                  size={30}
                                  onClick={() =>
                                    save(scaleData.id, ele.id, indexId)
                                  }
                                />
                              </Grid>
                            ) : (
                              scaleData.iconChecked && (
                                <Grid item xs={12} sm={2}>
                                  <AiOutlineEdit
                                    size={23}
                                    onClick={() =>
                                      EditHandle(scaleData.id, ele.id, indexId)
                                    }
                                  />
                                </Grid>
                              )
                            )}
                            {scaleData.iconChecked ? (
                              <Grid item xs={12} sm={2}>
                                <AiFillDelete
                                  style={{ marginTop: '0px' }}
                                  size={22}
                                  onClick={() =>
                                    deleteHandle(scaleData.id, ele.id)
                                  }
                                />
                              </Grid>
                            ) : (
                              ''
                            )}

                            {scaleData.iconChecked &&
                            scaleData.rows.length == i + 1 ? (
                              <Grid item xs={12} sm={2}>
                                <Button
                                  // style={{ marginTop: '19px' }}
                                  variant="contained"
                                  color="primary"
                                  // label=""
                                  onClick={() =>
                                    handleNewRow(scaleData.id, ele.id)
                                  }
                                >
                                  Add New
                                </Button>
                              </Grid>
                            ) : (
                              ''
                            )}
                          </Grid>
                        </>
                      );

                      // });
                    })}
                    {!scaleData.iconChecked && (
                      <div className="main-btn-part">
                        <Button
                          // style={{ float: 'right' }}
                          variant="contained"
                          color="primary"
                          // label=""
                          onClick={() =>
                            handleAllSave(
                              scaleData.id,
                              indexId,
                              scaleData.iconChecked
                            )
                          }
                        >
                          save
                        </Button>
                      </div>
                    )}
                  </KenCard>
                </AccordionDetails>{' '}
              </Accordion>
            </>
          );
        })}
        <div className="main-btn-part">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleScaleAccordien()}
          >
            Add New Scale
          </Button>
        </div>
      </Box>
    </div>
  );
};

export default GradeScale;